// extracted by mini-css-extract-plugin
export default {"card-container":"styles_card-container__+mUj5 styles_card-container__vvx9S px-3 py-4"};